import {NoteLinkedObject, NotePart, NotePartType} from 'notebook/util/NoteUtilConstants';

export default function getNotePartType(notePart: NotePart): string | null {
  if (notePart.type !== NotePartType.NOTE_LINKED_OBJECT) {
    return notePart.type;
  }
  if (!notePart.item) {
    return null;
  }
  return (notePart.item as NoteLinkedObject).type;
}
